import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/Button';
import { Check, Award, Users, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
export function About() {
  return <Layout data-id="element-138">
      {/* Hero Section */}
      <section className="relative py-32 px-4 border-b border-taupe-200 overflow-hidden" data-id="element-139">
        {/* Background Image */}
        <div className="absolute inset-0" data-id="element-140">
          <img src="https://cdn.magicpatterns.com/uploads/mK8onWKnqpj2phunVGmDXi/About_Hero-bg.jpg" alt="Down Home Interiors Design" className="w-full h-full object-cover object-center" data-id="element-141" />
          <div className="absolute inset-0 bg-white/80" data-id="element-142" />
        </div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-143">
          <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-6 block" data-id="element-144">
            Our Story
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-charcoal-900 mb-6 leading-tight" data-id="element-145">
            Creating Beautiful Spaces
            <br data-id="element-146" />
            <span className="italic" data-id="element-147">for Over Two Decades</span>
          </h1>
          <p className="text-xl text-charcoal-900/70 leading-relaxed max-w-2xl mx-auto" data-id="element-148">
            Down Home Interiors has been serving clients in Michigan and
            Southwest Florida with trusted interior design, home décor, and
            staging services since 2003.
          </p>
        </div>
      </section>

      {/* About the Owner - Denise Down */}
      <section className="py-24 px-4 bg-white" data-id="element-149">
        <div className="max-w-6xl mx-auto" data-id="element-150">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-151">
            <div className="aspect-[3/4] overflow-hidden" data-id="element-152">
              <img src="https://cdn.magicpatterns.com/uploads/9H7jKLYV8wEgtLFLzkYWxZ/About-the-Owner.jpg" alt="Denise Down - Owner of Down Home Interiors" className="w-full h-full object-cover" data-id="element-153" />
            </div>
            <div data-id="element-154">
              <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-4 block" data-id="element-155">
                Meet the Owner
              </span>
              <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-156">
                Denise Down
              </h2>
              <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-157">
                With 20 plus years of experience in interior design as well as
                the gift and home décor industry, Denise Down heads all work
                done by Down Home Interiors including new home renovation, new
                construction, and real estate staging. Her accolades include
                numerous appointments to advisory boards in the field of
                marketing, design, and product development. She has received
                many awards, including top sales achievement for several US gift
                companies.
              </p>
              <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-158">
                Denise has been a keynote speaker on behalf of the interior
                design and giftware companies, and she has conducted training
                seminars in merchandising for the wholesale industry, as well as
                seminars for the residential homeowner.
              </p>
              <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-159">
                She has worked as a consultant in the corporate field of product
                development specializing in design, color, and concept. Her love
                for people and service for each job small or large has
                contributed to her success.
              </p>
              <p className="text-lg text-charcoal-900/70 leading-relaxed mb-8" data-id="element-160">
                Her focus and concentration is primarily residential interior
                design. Her extensive portfolio speaks for itself. Her
                consultation fee is affordable for all budgets. Denise and her
                husband, Bill have four children.
              </p>
              <div className="flex items-center gap-4 text-sm text-charcoal-900/60" data-id="element-161">
                <div className="flex items-center gap-2" data-id="element-162">
                  <Award className="text-sage-500" size={18} data-id="element-163" />
                  <span data-id="element-164">20+ Years Experience</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-165">
                  <Users className="text-sage-500" size={18} data-id="element-166" />
                  <span data-id="element-167">500+ Projects</span>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-taupe-200" data-id="element-168">
                <p className="text-lg text-charcoal-900/70 mb-6" data-id="element-169">
                  Ready to bring your design vision to life?
                </p>
                <a href="tel:5175455955" data-id="element-170">
                  <Button size="lg" data-id="element-171">Call to Get Started</Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What We Do */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-172">
        <div className="max-w-6xl mx-auto" data-id="element-173">
          <div className="text-center mb-16" data-id="element-174">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-175">
              What We Do
            </h2>
            <p className="text-lg text-charcoal-900/60 max-w-2xl mx-auto" data-id="element-176">
              Comprehensive design services and curated retail offerings
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-177">
            {[{
            title: 'Interior Design',
            description: 'Full-service design from concept to completion. We handle space planning, color selection, furniture sourcing, and installation to create cohesive, livable spaces that reflect your personal style. Serving clients in Michigan and Southwest Florida.'
          }, {
            title: 'Retail Home Décor',
            description: 'Our retail store features a carefully curated collection of home accessories, décor, and apparel. From statement pieces to finishing touches, find everything you need to complete your space.'
          }, {
            title: 'Real Estate Staging',
            description: 'Professional staging services that help homes sell faster and for more. We know what buyers want to see and how to present your property in its best light.'
          }, {
            title: 'Window Treatments',
            description: 'Custom drapery, blinds, and shades designed to enhance your windows while providing privacy and light control. We handle measuring, fabrication, and professional installation.'
          }, {
            title: 'Custom Furnishings',
            description: "Can't find exactly what you're looking for? We work with trusted craftspeople to create custom furniture and upholstery pieces tailored to your specifications."
          }, {
            title: 'Design Consultations',
            description: 'Not ready for a full project? Call us for expert guidance on color, layout, and styling to help you make confident design decisions.'
          }].map((service, index) => <div key={index} className="bg-white p-8 border border-taupe-200 shadow-card" data-id="element-178">
                <h3 className="text-xl font-serif text-charcoal-900 mb-4" data-id="element-179">
                  {service.title}
                </h3>
                <p className="text-charcoal-900/70 leading-relaxed" data-id="element-180">
                  {service.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Why Clients Choose Us */}
      <section className="py-24 px-4 bg-white" data-id="element-181">
        <div className="max-w-5xl mx-auto" data-id="element-182">
          <div className="text-center mb-16" data-id="element-183">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-184">
              Why Clients Choose Down Home Interiors
            </h2>
            <p className="text-lg text-charcoal-900/60" data-id="element-185">
              What sets us apart in the world of interior design
            </p>
          </div>

          <div className="space-y-8" data-id="element-186">
            {[{
            icon: <Heart className="text-sage-500" size={24} data-id="element-187" />,
            title: 'Personalized Attention',
            description: "Every project receives hands-on involvement from Denise Down herself. We don't believe in cookie-cutter solutions—your home should be as unique as you are."
          }, {
            icon: <Award className="text-sage-500" size={24} data-id="element-188" />,
            title: 'Two Decades of Expertise',
            description: 'With over 20 years serving clients in Michigan and Southwest Florida, we bring deep knowledge of design principles, local resources, and proven processes that ensure successful outcomes.'
          }, {
            icon: <Check className="text-sage-500" size={24} data-id="element-189" />,
            title: 'Full-Service Convenience',
            description: 'From design to installation, we handle every detail. Our relationships with trusted contractors and craftspeople mean seamless execution from start to finish.'
          }, {
            icon: <Users className="text-sage-500" size={24} data-id="element-190" />,
            title: 'Local Retail Store',
            description: 'See and touch materials before you commit. Our retail location offers a curated selection of home décor and apparel, plus the ability to special order from our extensive vendor network.'
          }, {
            icon: <Heart className="text-sage-500" size={24} data-id="element-191" />,
            title: 'Timeless Design Philosophy',
            description: 'We create interiors that age gracefully. While we stay current with trends, our focus is on classic design principles that ensure your space looks beautiful for years to come.'
          }].map((point, index) => <div key={index} className="flex gap-6 items-start" data-id="element-192">
                <div className="flex-shrink-0 w-12 h-12 bg-sage-100 rounded-full flex items-center justify-center" data-id="element-193">
                  {point.icon}
                </div>
                <div data-id="element-194">
                  <h3 className="text-xl font-serif text-charcoal-900 mb-2" data-id="element-195">
                    {point.title}
                  </h3>
                  <p className="text-charcoal-900/70 leading-relaxed" data-id="element-196">
                    {point.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-4 bg-gradient-to-br from-taupe-200/50 to-cream-100" data-id="element-197">
        <div className="max-w-4xl mx-auto text-center" data-id="element-198">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-199">
            Ready to Start Your Project?
          </h2>
          <p className="text-xl text-charcoal-900/70 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-200">
            Visit our retail store to explore our collections or call us to
            discuss your design needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-201">
            <Link to="/store-info" data-id="element-202">
              <Button size="lg" className="min-w-[200px]" data-id="element-203">
                Visit the Retail Store
              </Button>
            </Link>
            <Link to="/contact" data-id="element-204">
              <Button variant="outline" size="lg" className="min-w-[200px]" data-id="element-205">
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>;
}